<template>
  <div>
    <section class="keyvisual">
      <h3 class="keyvisual__ttl">abceed premium</h3>
    </section>
    <app-loading v-if="isLoading"></app-loading>
    <div v-else>
      <main class="card-list" v-if="books.length > 0">
        <app-book v-for="(book, index) in books" :bookInfo="book" :key="book.id_book + '-search-page-' + index"></app-book>
      </main>
      <main class="card-list" v-else>
        <div class="search-no-result">
          「{{this.$route.params.words}}」で検索した結果、<br class="sp-on">該当する書籍はありませんでした。
        </div>
      </main>
    </div>
  </div>
</template>

<script>
  import TopInformation from '../common/TopInformation.vue';
  import Book from '../books/Book.vue';
  import { topInformation } from '../../constants';
  import Loading from '../common/Loading.vue';

  export default {
    title: '検索結果 - abceed analytics',
    headerTitle: '検索結果',
    components: {
      appTopInformation: TopInformation,
      appBook: Book,
      appLoading: Loading
    },
    data() {
      return {
        topInformation
      }
    },
    created() {
      if (this.books.length === 0) {
        this.$store.dispatch("changeLoadingCondition", true);
        this.$store.dispatch("searchBook", this.$route.params.words)
          .then(() => {
            this.$store.dispatch("changeLoadingCondition", false);
          }).catch(() => {
            this.$store.dispatch("changeLoadingCondition", false);
          });
      }
    },
    computed: {
      books() {
        return this.$store.getters.searchBooks;
      },
      isLoading() {
        return this.$store.getters.isLoading;
      }
    }
  }
</script>

<style scoped lang="scss">
  .search-no-result {
    background-color: #fff;
    padding: 30px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/bookList/Search.vue